import React, { useState } from "react";
import { Search } from "lucide-react";

const FlashAlertsFilterBar = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [region, setRegion] = useState("");
    const [sortOrder, setSortOrder] = useState("newest");

    return (
        <div className="w-full rounded-md px-3 py-2 bg-[#F9FAFB] flex flex-col md:flex-row items-center justify-between gap-2 min-h-[48px]">
            {/* Left: Search */}
            <div className="relative w-full md:w-[250px]">
                <Search className="absolute left-2 top-2.5 text-[#9CA3AF]" size={16} />
                <input
                    type="text"
                    placeholder="Search alerts..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="w-full rounded-md pl-8 pr-2 py-1.5 border border-[#D1D5DB] text-[#111827] bg-[#FFFFFF] text-sm focus:ring-1 focus:ring-[#6366F1] focus:outline-none"
                />
            </div>

            {/* Right: Region + Sort */}
            <div className="flex items-center gap-2 ml-auto">
                <select
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    className="rounded-md border border-[#D1D5DB] text-[#111827] bg-[#FFFFFF] px-2 py-1.5 text-sm focus:ring-1 focus:ring-[#6366F1] focus:outline-none"
                >
                    <option value="">All Regions</option>
                </select>

                <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                    className="rounded-md border border-[#D1D5DB] text-[#111827] bg-[#FFFFFF] px-2 py-1.5 text-sm focus:ring-1 focus:ring-[#6366F1] focus:outline-none"
                >
                    <option value="newest">Newest first</option>
                    <option value="oldest">Oldest first</option>
                </select>
            </div>
        </div>

    );
};

export default FlashAlertsFilterBar;
